/**
 * ImageModal — the Media Centre image lightbox modal.
 * Extracted from MediaCentre.js; behaviour identical to the original inline block.
 */
import React from 'react';

function ImageModal({ image, imageUrl, onClose }) {
    const title = image.topic;

    return (
        <div className="image-modal-overlay" onClick={onClose}>
            <div className="image-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="image-modal-header">
                    <h3>
                        <span>{title.length > 50 ? `${title.substring(0, 50)}...` : title}</span>
                    </h3>
                    <button className="image-modal-close" onClick={onClose} title="Close image">
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <div className="image-modal-content">
                    <img src={imageUrl || image.webURLLink} alt={title} />
                </div>
                <div className="image-modal-info">
                    <div className="image-modal-meta media-meta">
                        <span>
                            <i className="fas fa-calendar"></i>{' '}
                            {new Date(image.publishDate).toLocaleDateString('en-GB', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                            })}
                        </span>
                        <span className="entity"><i className="fas fa-building"></i> {image.entity}</span>
                        {image.shortDescription && (
                            <div className="image-description">
                                <p>{image.shortDescription}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImageModal;
